import React from 'react'
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import axios from "axios"
import { ReactComponent as Arrow } from "../assets/arrow.svg"

import Title from "../components/global/Title/Title"
import Content from "../components/global/Content/Content"
import Animation from "../components/global/Animation/Animation"

import { Loader } from "../components/common/Loader/Loader"

export default class RadjeScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ loading: true });

    axios.get('/wp-json/wp/v2/pages/1065')
      .then(res => {
        this.setState({ data: res.data, loading: false });
      })
      .catch(error => {
        console.error(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { data, loading } = this.state;

    return (
      loading ? <Loader /> :
      <div>
        <Helmet>
          <title>{data.yoast_title || 'Default Title'}</title>
          {data.yoast_meta && data.yoast_meta.map((meta, index) => (
            <meta key={index} name={meta.name} content={meta.content} />
          ))}
          <script src="https://shop.eventix.io/build/integrate.js" crossorigin="anonymous" async></script>
        </Helmet>
        <section className="relative p-0 pt-16">
          <Animation />
          <div className="max-w-screen-xl mx-auto sm:px-4 md:px-6 lg:px-8 z-10 relative">
            <div className="ml-1-col w-3/4 py-32">
              <div className="breadcrumb-bar" style={{color: "#F58120"}}>
                <div className="breadcrumb"><Link to="/">Home</Link><div className="px-2 breadcrumb-seperator"><Arrow/></div></div>
                <div className="breadcrumb" style={{color: "#000"}}>Radje voor de sfeer</div>
              </div>
              <Title level="1" className="underlined">{ data.title && data.title.rendered }</Title>
              <Content className="mt-10 w-full">{ data.content && data.content.rendered }</Content>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
